import axios from 'axios';
import { API_URL } from '../ApiConfig'; // Importa a URL base da API


export const ListUser = async (costumerData) => {
  try {
      const response = await axios.get(`${API_URL}/listUser`, {
          params: costumerData, // Envia os dados como query params
      });
      return response.data;
  } catch (error) {
      console.error('Erro ao listar clientes:', error.response?.data || error.message);
      return { success: false, message: 'Erro ao listar clientes' };
  }
};
